/**
 * modifyLimit — validating wrapper for the `modify-limit` SR-Edit op. Empty /
 * whitespace values clear that part; clearing both removes the whole clause.
 * The applicator preserves the statement's dialect style (TOP / LIMIT+OFFSET /
 * OFFSET…FETCH / FETCH FIRST) when replacing.
 */
import type { CommitEditCtx } from '../commitEdit';
import { commitEdit } from '../commitEdit';

export interface ModifyLimitValues {
  readonly count?: string;
  readonly offset?: string;
}

const NUMERIC = /^\d+$/;

export async function modifyLimit(values: ModifyLimitValues, ctx: CommitEditCtx): Promise<void> {
  const count = values.count?.trim() || undefined;
  const offset = values.offset?.trim() || undefined;
  if (count !== undefined && !NUMERIC.test(count)) {
    throw new Error(`modifyLimit: count must be a non-negative integer (got "${count}")`);
  }
  if (offset !== undefined && !NUMERIC.test(offset)) {
    throw new Error(`modifyLimit: offset must be a non-negative integer (got "${offset}")`);
  }
  await commitEdit({ op: 'modify-limit', count, offset }, ctx);
}
